/**
 * Define all variables related to storage
 * Exp: cookie, local storage, session storage...
 * */

const COOKIES = {
    accessToken: 'access_token',
}

const BABY = {
    SELECTED: 'baby_selected',
}

export {
    COOKIES, BABY
}
